import { Component } from '@angular/core';
import { BlockSpiderChart } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-spider-chart',
  templateUrl: './block-spiderChart.component.html',
})
export class BlockSpiderChartComponent extends BlockAbstractComponent<BlockSpiderChart, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
